// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__l-4NL","unreadBadge":"styles_unreadBadge__3uIwY","modalContent":"styles_modalContent__2E3Ur","modal":"styles_modal__2DgJx"};